import Space from './Space'
export default Space
